import React from 'react'

const CoreComponenet7 = ({imgcontent}) => {
  return (
    <div className="row   d-flex flex-wrap justify-content-center align-items-center pt-md-2 ">      
            {imgcontent.map((val, i) => (
            <div key={i} className={`col-lg-3 col-md-3 col-12 ${val.line} d-flex  mt-5 justify-content-center `} >
              <div className="clippath-squre bg-light  text-black hover-box  p-4 p-md-0 d-flex flex-column flex-wrap justify-content-center align-items-center">
                <div className='trans-rotate'>

                <img src={val.icon} alt="" className= "icon   mb-2"     style={{ filter: 'grayscale(100%) brightness(0)' }} />
                <h3 className="h3-heading title fs-5  text-black  ">{val.title}</h3>
                <p className=" desc d-md-none text-black lh-1 px-1  pt-2 text-center" style={{fontSize:13}}>{val.desc}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
  )
}

export default CoreComponenet7